import { uuidv4 } from './Cookies/index'
import triplaLocalStorage from 'Utilities/triplaLocalStorage'
import { useTermsConditionsStore } from 'Store/terms-conditions'
import { SessionStorageKeys } from 'javascript/Constants'
import { getDomainWithoutSubdomain } from 'javascript/Utilities/index'
import { useSettingsStore } from 'Store/settings'
import Cookies from 'js-cookie'
import { useCookieConsentStore } from 'Store/cookie-consent'
const limitCookiesCount = 5

function storageKey() {
  const restaurentCode = sessionStorage.getItem(SessionStorageKeys.RESTAURENT_CODE)
  if (restaurentCode) {
    return `triplabot_restaurant_session_${restaurentCode}`
  } else {
    return 'triplabot_session'
  }
}

function getTriplabotSessionKeyInCookie() {
  const settingsStore = useSettingsStore()
  return `${storageKey()}_${settingsStore.settings?.hotel_id}`
}

function removeCookies(cookieName) {
  Cookies.remove(cookieName, { domain: getDomainWithoutSubdomain(window.location.toString()) })
  Cookies.remove(cookieName, { path: '' })
}

export function storeSession(session) {
  triplaLocalStorage.setItem(storageKey(), session)
  Cookies.set(getTriplabotSessionKeyInCookie(), `${session}|${Date.now()}`, {
    Domain: getDomainWithoutSubdomain(window.location.toString()),
    'Max-Age': '315360000', // 1 year
    'Same-Site': 'Strict'
  })
  removeSomeOldestSessions()
}

function removeSomeOldestSessions() {
  Object.entries(Cookies.get())
    .filter(([key]) => key.startsWith('triplabot_session_'))
    .map(([key, value]) => {
      return {
        key,
        createdAt: value.match(/\|\d+$/)?.[0].slice(1) || 0
      }
    })
    .sort((c1, c2) => Number(c2.createdAt) - Number(c1.createdAt))
    .slice(5)
    .forEach(cookie => {
      removeCookies(cookie.key)
    })
}

export function removeSession() {
  triplaLocalStorage.removeItem(storageKey())
  removeCookies(getTriplabotSessionKeyInCookie())
  const termsConditionsStore = useTermsConditionsStore()
  const cookieConsentStore = useCookieConsentStore()

  // TODO: move this logic to User module when we have it
  triplaLocalStorage.removeItem('triplabot_known_user_signed_in')
  triplaLocalStorage.removeItem('triplabot_known_user_id')
  termsConditionsStore.setAccepted(false)
  cookieConsentStore.clearCookiePreferences()
}

export function getSession() {
  return triplaLocalStorage.getItem(storageKey())
}

export function initUID(cname) {
  let uid = triplaLocalStorage.getItem(cname)

  if (!uid) {
    uid = uuidv4()
    triplaLocalStorage.setItem(cname, uid)
  }

  return uid
}
